import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Pane extends Component {
  displayName: 'Pane'

  static propTypes = {
    analytics: PropTypes.shape({
      pagename: PropTypes.string,
      pagegroup: PropTypes.string,
    }),
    comp: PropTypes.func.isRequired,
    label: PropTypes.string,
    message: PropTypes.string,
  }

  render() {
    const Comp = this.props.comp
    if (Comp) {
      return (
        <Comp
          analytics={this.props.analytics}
          message={this.props.message}
        />
      )
    }
    return <div>{`Your content for ${this.props.label} goes here.`}</div>
  }
}

export default Pane
